import React from 'react';
import { HeroSection } from '../components/landing/HeroSection';
import { WhyParticipateSection } from '../components/landing/WhyParticipateSection';
import { HowItWorksSection } from '../components/landing/HowItWorksSection';
import { KeyBenefitsSection } from '../components/landing/KeyBenefitsSection';
import { CommitmentsSection } from '../components/landing/CommitmentsSection';
import { TestimonialsSection } from '../components/landing/TestimonialsSection';
import { ApplicationFormSection } from '../components/landing/ApplicationFormSection';
import { AboutEediSection } from '../components/landing/AboutEediSection';
import { TeamSection } from '../components/landing/TeamSection';
import { PromoBanner } from '../components/landing/PromoBanner';
export function LandingPage() {
  return <div className="w-full" data-id="element-504">
      <HeroSection data-id="element-505" />
      <WhyParticipateSection data-id="element-506" />
      <HowItWorksSection data-id="element-507" />
      <KeyBenefitsSection data-id="element-508" />
      <CommitmentsSection data-id="element-509" />
      <AboutEediSection data-id="element-510" />
      <TeamSection data-id="element-511" />
      <TestimonialsSection data-id="element-512" />
      <ApplicationFormSection data-id="element-513" />
      <PromoBanner data-id="element-514" />
    </div>;
}